package com.macrofocus.eflux.ui

import js.objects.unsafeJso
import mui.material.Container
import mui.material.FormControl
import mui.material.FormControlVariant
import react.FC
import react.PropsWithChildren
import web.cssom.pct

val FieldControl = FC<PropsWithChildren> { props ->
//    val classes = useStyles()

    Container {
//        attrs.classes = classes.fieldControl
        sx = unsafeJso {
            width = 100.pct
        }

        FormControl {
            fullWidth = true

//            attrs.classes = classes.formControl
//            css {
//                width = 100.pct
//            }
            variant = FormControlVariant.outlined
            +props.children
        }
    }
}